/**
 * Utility per gestione versione semver (formato MAJOR.MINOR.PATCH).
 * Per il periodo BETA usiamo 0.MAJOR.MINOR (la prima cifra resta 0 finché siamo in beta).
 */

/**
 * Confronta due stringhe versione semver.
 * Ritorna numero negativo se a < b, positivo se a > b, 0 se uguali.
 * Esempio: compareVersions('0.2.10', '0.3.0') => -1
 */
export function compareVersions(a, b) {
  const aParts = String(a).split('.').map((n) => parseInt(n, 10) || 0);
  const bParts = String(b).split('.').map((n) => parseInt(n, 10) || 0);
  const len = Math.max(aParts.length, bParts.length);
  for (let i = 0; i < len; i += 1) {
    const diff = (aParts[i] || 0) - (bParts[i] || 0);
    if (diff !== 0) return diff;
  }
  return 0;
}

/**
 * Ritorna la versione piu' alta tra le release fornite, oppure null se vuoto.
 */
export function getLatestVersion(releases) {
  if (!releases || !releases.length) return null;
  return [...releases]
    .sort((a, b) => compareVersions(b.version, a.version))[0]
    .version;
}

/**
 * Ritorna le release ordinate dalla piu' recente alla piu' vecchia.
 */
export function sortReleasesDesc(releases) {
  return [...releases].sort((a, b) => compareVersions(b.version, a.version));
}
